import controller from './cta-buttons-details.controller';
import template from './cta-buttons-details.html';
import './cta-buttons-details.less';

const component = {
    template,
    bindings: {
        entity: '<',
        locale: '<',
        menus: '<',
    },
    controller: [controller],
};

export default component;
